import React, { useState } from 'react';
import { Select } from '@byte-design/ui';
import { ReactComponent as Logo } from '@/assets/tt4d-new-logo.svg';
import styles from './index.module.scss';

const ADS_BASE_PATH = 'https://ads.tiktok.com';
const BASE_PATH = 'https://business-api.tiktok.com/portal/';

interface LanguageOption {
  value: string;
  label: string;
}

const LANGUAGES: LanguageOption[] = [
  { value: 'ENGLISH', label: 'English' },
  { value: 'CHINESE', label: '简体中文' },
];

interface HeaderProps {
  isAuthPage?: boolean;
  languages?: LanguageOption[];
  defaultLanguage?: string;
  onLanguageChange?: (language: string) => void;
}

const Header: React.FC<HeaderProps> = ({
  isAuthPage = false,
  languages = LANGUAGES,
  defaultLanguage = 'ENGLISH',
  onLanguageChange,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(defaultLanguage);

  const handleLogoClick = () => {
    window.location.href = isAuthPage ? ADS_BASE_PATH : BASE_PATH;
  };

  const handleLanguageChange = (value: string | undefined) => {
    if (value) {
      setSelectedLanguage(value);
      onLanguageChange?.(value);
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.logoContainer} onClick={handleLogoClick}>
        <Logo className={styles.logo} />
      </div>
      <div className={styles.languageSelector}>
        <Select
          value={selectedLanguage}
          onValueChange={handleLanguageChange}
          size="md"
          width="120px"
        >
          {languages.map((language) => (
            <Select.Option
              key={language.value}
              value={language.value}
              label={language.label}
            />
          ))}
        </Select>
      </div>
    </div>
  );
};

export default React.memo(Header);
